export default __webpack_public_path__ + "static/media/zenyatta-icon.a957ec52.webp";